import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { EnvironmentConfig, ENV_CONFIG } from 'src/app/core/enviroment-config';
import { ReadApiService } from 'src/app/core/service/abstract/read-api.service';
import { CrudApiService } from 'src/app/core/service/abstract/rest-api.service';
import { UserTableVisualization } from 'src/app/data/model/user';
import { ApiModule } from '../api.module';

@Injectable({
  providedIn: ApiModule
})
export class UserTableVisualizationApiService extends ReadApiService<UserTableVisualization> {
  constructor(http: HttpClient, @Inject(ENV_CONFIG) config: EnvironmentConfig) {
    super('portal/auth/table-visual', http, config);
  }
}
